import { Outlet } from "react-router-dom";

export default function ManagementOutlet() {
  return <Outlet />;
}
